<template>
  <router-view/>
</template>

<style lang="scss">
#app {
  background: #000000;
  min-height: 100vh;
}
</style>
